module.exports = __webpack_public_path__ + "276174e209116ce3a607d82128aa0319.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1155
// module chunks = 0